/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export const loadingPayoutDetailConfig = {
  loading: {
    loadingProfile: {
      image:
        'https://s3.ap-south-1.amazonaws.com/io.vlinder.illustrations/fhp_loading_illustration_2.png',
      titleNormalText: 'Please wait while ',
      titleBoldText: 'we retrieve payout details...',
      description: 'This may take a few moments. Thank you for your patience.',
    },
    updatePayout: {
      image:
        'https://s3.ap-south-1.amazonaws.com/io.vlinder.illustrations/fhp_loading_illustration_2.png',
      titleNormalText: 'Updating ',
      titleBoldText: 'payout...',
      description: 'This might take few seconds, Please wait !',
    },
    sendReminder: {
      image:
        'https://s3.ap-south-1.amazonaws.com/io.vlinder.illustrations/fhp_loading_illustration_2.png',
      titleNormalText: 'Sending ',
      titleBoldText: 'email reminder...',
      description: 'This might take few seconds, Please wait !',
    },
  },
};
